/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { IMixpanelUser, IMixpanelUserProps } from '../models/IMixpanelUser';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  private _user: IMixpanelUser;
  private _token: string;
  private _trackingDisabled: boolean;

  disbaleTracking(): void {
    this._trackingDisabled = true;
  }

  private trackingIsDisabled() {
    return this._trackingDisabled;
  }

  public setToken(token: string): void {
    if (!token) {
      this.disbaleTracking();
      return;
    }
    this._token = token;
    mixpanel.init(this._token, {
      api_host: 'https://api-eu.mixpanel.com',
    });
  }

  public identify(
    user: IMixpanelUser,
    userProps: IMixpanelUserProps,
    userIdentifier: string,
  ): void {
    if (!this._token) return;
    if (this.trackingIsDisabled()) return;
    const stableId = user?.legalEntityId;
    if (!stableId) {
      return;
    }
    if (this._user?.legalEntityId === stableId) {
      return;
    }
    this._user = user;

    mixpanel.reset();
    mixpanel.register({ distinct_id: stableId });
    mixpanel.identify(stableId);

    mixpanel.people.set({
      $name: user.legalEntityName,
      ...user,
    });
  }

  public track(eventName: string, payload: object = {}): void {
    if (this.trackingIsDisabled() || !this._user || !this._token) return;
    mixpanel.track(eventName, payload);
  }

  public reset(): void {
    if (!this._token) return;
    this._user = undefined;
    mixpanel.reset();
  }

  public trackPageView(pageName: string): void {
    if (!this._token) return;
    this.track(pageName);
  }
}
